<template>
  <v-container grid-list-md text-xs-center v-if="isPixPaymentEnabled">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card color="white">
          <v-card-text class="px-0">
            <h2 class="font-weight-light pb-3">Pagamentos PIX</h2>
            <PaymentIcon name="pix" size="120" color="#32BCAD" class="pb-5" />
            <h2 v-if="partner === 'establishment'" class="font-weight-light">
              {{ staticMessage }} {{ account.fantasy_name }}!
            </h2>
            <h2 v-else class="font-weight-light">
              {{ staticMessage }} {{ partnerName }}!
            </h2>
          </v-card-text>
          <v-list three-line>
            <new-pix-payment />
            <v-divider inset></v-divider>
            <br>
            
            <!-- Seção Meus Pagamentos PIX integrada ao card principal -->
            <v-list-tile>
              <v-list-tile-content>
                <v-card-actions class="headline font-weight-bold pa-0">
                  <div class="headline font-weight-bold">Meus Pagamentos PIX</div>
                  <v-spacer></v-spacer>
                  <v-btn fab small @click="showFilters">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </v-card-actions>
                <div style="font-size: 16px; font-weight: 400; padding-top: 8px;">
                  <h3 style="font-weight: 700">
                    Total do período: {{ $n(totalPixPayments, "currency") }}
                  </h3>
                  <i>Utilize os Filtros para melhorar a sua busca.</i>
                </div>
              </v-list-tile-content>
            </v-list-tile>
            
            <v-divider></v-divider>
            <br>
            
            <pix-payment-table />
          </v-list>
        </v-card>
        <pix-payment-filters />
      </v-flex>
    </v-layout>
  </v-container>
  <v-container grid-list-md text-xs-center class="background-billing" v-else>
    <v-layout row wrap class="align-bill">
      <v-card class="mx-auto" max-width="600" style="margin-top: 50px;">
        <v-card-text class="text-center">
          <v-icon size="64" color="grey lighten-1" class="mb-4">block</v-icon>
          <h2 class="headline mb-3">Sistema de Pagamento PIX Desabilitado</h2>
          <p class="body-1 grey--text text--darken-1">
            Esta funcionalidade não está disponível no momento. 
            Entre em contato com seu representante para habilitar pagamentos PIX.
          </p>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";
import PaymentIcon from '@/components/PaymentIcon.vue';

export default {
  name: "PixPayment",
  created() {
    this.$store.dispatch("system/fetchSystemConfiguration").then(() => {
      this.$store.dispatch("account/getAccount");
    });
    // Carregar lista de pagamentos PIX se disponível
    if (this.$store.dispatch['bills/loadPixPayments']) {
      this.$store.dispatch('bills/loadPixPayments');
    }
  },
  mounted() {
    // Se a rota atual termina com "/new", abrir automaticamente o formulário
    if (this.$route.path.endsWith('/new')) {
      this.$nextTick(() => {
        EventBus.$emit("show-new-pix-payment-form");
      });
    }
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      partner: "account/partner",
      partnerName: "account/partnerName",
      pixPaymentList: "bills/pixPaymentList",
      pixPaymentResourcesCount: "bills/pixPaymentResourcesCount"
    }),
    isPixPaymentEnabled() {
      // Verificar se o PIX está habilitado para a conta
      return this.account && this.account.active_pix_payment === true;
    },
    totalPixPayments() {
      // Calcular total dos pagamentos PIX listados
      const resources = this.pixPaymentList || [];
      if (resources.length === 0) return 0;
      return resources.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
    }
  },
  data() {
    return {
      staticMessage: "Realize pagamentos instantâneos via PIX direto da sua conta digital",
    };
  },
  methods: {
    showFilters() {
      // Implementar filtros específicos para PIX se necessário
      this.$store.dispatch("bills/showFilters", true);
    }
  },
  components: {
    PaymentIcon,
    newPixPayment: () => import("@/components/desktop/bills/NewPixPayment.vue"),
    pixPaymentTable: () => import("@/components/desktop/bills/PixPaymentTable.vue"),
    pixPaymentFilters: () => import("@/components/desktop/bills/Filters.vue"),
  },
};
</script>

<style>
  .background-billing {
    background-color: #FFFFFF;
  }
  .align-bill {
    display: block;
    text-align: center;
  }
</style>